import { component } from "picoapp";

export const accordionGroup = component((node) => {
  const accordionButtons = node.querySelectorAll(".js-accordion-button");

  const handleAccordionToggle = function (e) {
    if (e.currentTarget.parentElement.dataset.isOpen === "true") {
      const otherAccordionButtons = Array.from(accordionButtons).filter(
        (element) => element !== e.currentTarget
      );
      otherAccordionButtons.forEach((button: HTMLButtonElement) => {
        if (button.parentElement.dataset.isOpen === "true") {
          button.dispatchEvent(new Event("tbsp:close-accordion"));
        }
      });
    }
  };

  accordionButtons.forEach((button) =>
    button.addEventListener("click", handleAccordionToggle)
  );

  return (node: HTMLButtonElement) => {
    accordionButtons.forEach((button) =>
      button.removeEventListener("click", handleAccordionToggle)
    );
  };
});
